<template>
	<BasePopover placement="bottom" :z-index="13">
		<template #default="{ open }">
			<button
				:class="[
					'text-gray-700 flex h-7 w-7 items-center justify-center rounded-md font-semibold uppercase transition-colors hover:text-gray-900 hover:bg-gray-100 focus:bg-white focus:outline-none focus:ring-1 focus:ring-gray-300',
					buttonClass,
					{
						'text-xs': size == 'sm',
						'text-sm': size == 'md'
					}
				]"
				:title="$t('change_language')"
				@click="open"
			>
				{{ currentLocale.name }}
			</button>
		</template>
		<template #menu="{ isOpen, close }">
			<div v-if="isOpen" class="bg-white border-gray-200 mt-1 w-28 rounded-md border shadow-sm">
				<div class="py-1">
					<button
						v-for="locale in availableLocales"
						:key="locale.code"
						class="text-gray-700 flex w-full items-center px-3 py-2 text-sm font-medium lowercase hover:text-gray-900 hover:bg-gray-50 disabled:text-gray-900 disabled:bg-gray-50"
						:disabled="locale.code === currentLocale.code"
						@click="
							async () => {
								i18nRedirected = locale.code
								await setLocale(locale.code)
								close()
							}
						"
					>
						<span class="flex-grow text-start">{{ locale.name }}</span>
						<Icon
							v-if="locale.code === currentLocale.code"
							name="mdi:check"
							class="text-gray-900 -me-0.5 ms-2 h-3.5 w-3.5"
						/>
					</button>
				</div>
			</div>
		</template>
	</BasePopover>
</template>

<script setup lang="ts">
const { locales, setLocale, localeProperties } = useI18n()

const app = useNuxtApp()

const i18nRedirected = useCookie<typeof app.$i18n.defaultLocale>("i18n_redirected", {
	default: () => app.$i18n.defaultLocale
})

withDefaults(
	defineProps<{
		size?: "sm" | "md"
		buttonClass?: unknown
	}>(),
	{
		size: "md"
	}
)

const currentLocale = computed(() => localeProperties.value)
const availableLocales = computed(() => locales.value)
</script>
